<template>
  <v-container fluid text-xs-center>
    <v-layout row wrap light>
      <v-flex
        v-for="(partner, index) in partners"
        :key="`partner_${index}`"
        xs6 sm4 md3
        d-flex
      >
        <v-card flat tile class="d-flex" :color="'white'">
          <a :href="partner.url" target="_blank" rel="noopener norefererr">
            <v-img
              :src="imageURL(index)"
              aspect-ratio="1"
              class="white lighten-2"
              contain
            ></v-img>
          </a>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      partners: [
        {
          logo: 'biuro-partner.jpg',
          name: 'Biuro Partner',
          url: 'http://www.biuro-partner.pl/',
        },
        {
          logo: 'artisco.jpg',
          name: 'Artisco',
          url: 'http://artisco.pl/',
        },
        {
          logo: 'psoui.png',
          name: 'PSONI',
          url: 'http://psonipszczyna.pl/',
        },
        {
          logo: 'nowe-info.jpg',
          name: 'Nowe Info',
          url: 'https://www.noweinfo.pl/',
        },
      ],
    }
  },
  methods: {
    imageURL: function(id) {
      /* eslint-disable-next-line no-console */
      console.log('./../assets/img/thanks/' + this.partners[id].logo)
      return require('./../assets/img/thanks/' + this.partners[id].logo)
    }
  }
}
</script>
